import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const Icon = props =>
  <SvgIcon viewBox="0 0 516.375 516.375" {...props}>
    <path d="M353.812 0C263.925 0 191.25 72.675 191.25 162.562c0 19.125 3.825 38.25 9.562 57.375L0 420.75v95.625h95.625V459H153v-57.375h57.375l86.062-86.062c17.213 5.737 36.338 9.562 57.375 9.562 89.888 0 162.562-72.675 162.562-162.562S443.7 0 353.812 0zm47.813 172.125c-32.513 0-57.375-24.862-57.375-57.375s24.862-57.375 57.375-57.375S459 82.237 459 114.75s-24.862 57.375-57.375 57.375z" />
  </SvgIcon>;

export default Icon;



// WEBPACK FOOTER //
// ./src/options/icons/Key.jsx